/**
 * Admin Dashboard Version Information
 * Synced with main app: 1.1.8+25000143
 * Version: 1.1.8 (develop)
 * Build: 24-05-2026
 */

export const APP_VERSION = '1.1.8';
export const BUILD_DATE = '24-05-2026';
export const BUILD_NUMBER = '25000143';

export const getVersionString = (): string => {
  return `${APP_VERSION} (Build ${BUILD_NUMBER})`;
};

export const getFullVersionInfo = () => {
  return {
    version: APP_VERSION,
    buildDate: BUILD_DATE,
    buildNumber: BUILD_NUMBER,
    fullVersion: getVersionString(),
  };
};
